import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EstadoRecorridoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetByEstadoRecorrido(callback) {
        this.gqlclient.query({
            query: gql `
        query{
          estado_recorrido {
            obtenerTodos {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_recorrido.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    GetByEstadoRecorridoLisquidacion(callback) {
        this.gqlclient.query({
            query: gql `
        query{
          estado_recorrido {
            obtenerEstadoLiquidacion {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.estado_recorrido.obtenerEstadoLiquidacion;
            callback({ mensajes, respuesta });
        });
    }
}
EstadoRecorridoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EstadoRecorridoService_Factory() { return new EstadoRecorridoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EstadoRecorridoService, providedIn: "root" });
